module.exports = require('./react-lite-yt-embed.esm.js')
